import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get, find } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const getAttendeeMsg = (CourseAttendees, EmployeeMasterID, Gender) => {
  const found = find(CourseAttendees, ['EmployeeMasterID', EmployeeMasterID]);
  const attendeeType = get(found, 'CourseAttendeeType', 0);
  return <FormattedMessage id={`courseAttendeeType.${attendeeType}`} values={{ Gender }} />;
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js